import { PlanCode } from '../enums.js'
import { translate } from '../i18n.js'
import { PlanPriceDTO } from '../types.js'
import { formatMonthlyPrice } from '../utils/utils.js'

export class SubscriptionProductPlan {
    readonly data: PlanPriceDTO
    readonly locale: string
    readonly durationInMonths: number

    constructor(plan: PlanPriceDTO, locale: string, durationInMonths: number) {
        this.data = plan
        this.locale = locale
        this.durationInMonths = durationInMonths
    }

    get id() {
        return this.data.id + ''
    }

    get uuid() {
        return this.data.plan?.uuid
    }

    get code() {
        return this.data.plan?.code
    }

    get countryProductVat() {
        return this.data.country?.customVatPercentage
            ? this.data.country?.customVatPercentage
            : this.data.country?.vatPercentage
    }

    get countryVat() {
        return this.data.country?.vatPercentage
    }

    get currencySymbol() {
        return this.data.currency?.symbol || ''
    }

    get monthlyPriceNumberNet() {
        return this.data.priceWithoutVat
    }

    get monthlyPriceNumberGross() {
        return this.data.priceWithVat
    }

    get monthlyPrice() {
        return formatMonthlyPrice(this.data.priceWithVat, this.currencySymbol, this.locale)
    }

    get duration() {
        return this.durationInMonths
    }

    get isFlex() {
        return this.code === PlanCode.FLEX
    }

    get name() {
        if (this.isFlex) {
            return translate('existingSubscriptionStep.flexTitle', {
                lng: this.locale,
            })
        }

        return translate('existingSubscriptionStep.valueTitle', {
            lng: this.locale,
        })
    }
}
